// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"fo-z","badgeLink":"go-z","category":"ho-z"};